// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2kYTh","loading":"styles_loading__39exz","spin":"styles_spin__2YMCC"};